<ng-dialog-header title="Request Customer Number"></ng-dialog-header>
<mat-dialog-content>
  <h4>We detected the company does not have a valid customer number (this is required to sign a contract). Please provide the following information to
    send a request.</h4>
  <form [formGroup]="eidForm" class="pb-3">
    <mat-form-field appearance="outline" class="w-100">
      <mat-label>Official Customer Name:</mat-label>
      <input ngSpecialCharacter [regex]="pattern" matInput required formControlName="officialCustomer" aria-label="Official Customer Name">
      <mat-error *ngIf="eidForm.controls.officialCustomer.errors">
        This field is required
      </mat-error>
    </mat-form-field>
    <div class="row">
      <div class="col col-lg-9">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Address:</mat-label>
          <input ngSpecialCharacter matInput required formControlName="address" aria-label="Address">
          <mat-error *ngIf="eidForm.controls.address.errors">
            This field is required
          </mat-error>
        </mat-form-field>
      </div>
      <div class="col col-lg-3">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Zip:</mat-label>
          <input matInput required ngNumbersOnly maxlength="5" formControlName="zip" aria-label="Zip">
          <mat-error *ngIf="eidForm.controls.address.errors">
            This field is required
          </mat-error>
        </mat-form-field>
      </div>
    </div>
    <div class="row">
      <div class="col col-lg-9">
        <ns-autocomplete (selected)="autocompleteSelected('city', 'state')" [data]="states"
                         [formCtrl]="eidForm.controls.state" label="State" ngSpecialCharacter type="simple"
                         [isRequired]="true" maxLength="2">
        </ns-autocomplete>
      </div>
      <div class="col col-lg-3">
        <ns-autocomplete [data]="destinationStations" [filter]="false" [formCtrl]="eidForm.controls.city" label="City"
                         ngSpecialCharacter type="simple" [isLoading]="isLoadingCity" [isRequired]="true">
        </ns-autocomplete>
      </div>
    </div>
    <ns-autocomplete [data]="stccList" [filter]="false" [formCtrl]="eidForm.controls.stcc" label="Primary Commodity Being Shipped:"
                     ngSpecialCharacter type="simple" [isLoading]="isLoadingStcc" [isRequired]="true">
    </ns-autocomplete>
    <div class="pb-3">
      <mat-slide-toggle formControlName="differentAddress" (change)="handleMailAddressForm($event)">Use Different Mail Address</mat-slide-toggle>
      <mat-accordion>
        <mat-expansion-panel hideToggle [expanded]="eidForm.controls.differentAddress.value" class="mt-2">
          <ng-template matExpansionPanelContent>
            <mat-panel-description>
              Mailing Address
            </mat-panel-description>
            <div class="row">
              <div class="col col-lg-9">
                <mat-form-field appearance="outline" class="w-100">
                  <mat-label>Address:</mat-label>
                  <input matInput required formControlName="otherAddress" aria-label="Address">
                </mat-form-field>
              </div>
              <div class="col col-lg-3">
                <mat-form-field appearance="outline" class="w-100">
                  <mat-label>Zip:</mat-label>
                  <input matInput required ngNumbersOnly maxlength="5" formControlName="otherZip" aria-label="Zip">
                </mat-form-field>
              </div>
            </div>
            <div class="row">
              <div class="col col-lg-9">
                <ns-autocomplete (selected)="autocompleteSelected('otherCity', 'otherState')" [data]="states"
                                 [formCtrl]="eidForm.controls.otherState" label="State:" ngSpecialCharacter type="simple"
                                 [isRequired]="true" maxLength="2">
                </ns-autocomplete>
              </div>
              <div class="col col-lg-3">
                <ns-autocomplete [data]="destinationStations" [filter]="false" [formCtrl]="eidForm.controls.otherCity" label="City"
                                 ngSpecialCharacter type="simple" [isLoading]="isLoadingOtherCity" [isRequired]="true">
                </ns-autocomplete>
              </div>
            </div>
          </ng-template>
        </mat-expansion-panel>
      </mat-accordion>
    </div>
    <mat-form-field appearance="outline" class="w-100">
      <mat-label>Parent Company:</mat-label>
      <input matInput formControlName="parentCompany" aria-label="Parent Company">
    </mat-form-field>
    <mat-form-field appearance="outline" class="w-100">
      <mat-label>DUNS Number:</mat-label>
      <input matInput formControlName="dunsNumber" aria-label="DUNS Number">
    </mat-form-field>
    <div class="row">
      <div class="col col-lg-9">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Parent Company Address:</mat-label>
          <input matInput formControlName="parentCompanyAddress" aria-label="Parent Company Address" [required]="isParentAddressRequired">
          <mat-error *ngIf="eidForm.controls.parentCompanyAddress.hasError('required')">
            This field is required
          </mat-error>
        </mat-form-field>
      </div>
      <div class="col col-lg-3">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Zip:</mat-label>
          <input matInput ngNumbersOnly maxlength="5" formControlName="parentZip" aria-label="Zip" [required]="isParentAddressRequired">
          <mat-error *ngIf="eidForm.controls.parentZip.hasError('required')">
            This field is required
          </mat-error>
        </mat-form-field>
      </div>
    </div>
    <div class="row">
      <div class="col col-lg-9">
        <ns-autocomplete (selected)="autocompleteSelected('parentCity', 'parentState')" [data]="states"
                         [formCtrl]="eidForm.controls.parentState" label="State" ngSpecialCharacter type="simple"
                         [isRequired]="isParentAddressRequired" maxLength="2">
        </ns-autocomplete>
      </div>
      <div class="col col-lg-3">
        <ns-autocomplete [data]="destinationStations" [filter]="false" [formCtrl]="eidForm.controls.parentCity" label="City"
                         ngSpecialCharacter type="simple" [isLoading]="isLoadingParentCity"
                         [isRequired]="isParentAddressRequired">
        </ns-autocomplete>
      </div>
    </div>
    <mat-slide-toggle formControlName="thirdPartyProvider" (change)="setThirdParty($event)">
      Is Third Party Provider
    </mat-slide-toggle>
  </form>
</mat-dialog-content>
<ng-dialog-footer>
  <div class="d-flex justify-content-end overflow-hidden w-100" dialog-actions>
    <button mat-stroked-button color="warn" class="mr-2" mat-dialog-close>Cancel</button>
    <button mat-flat-button color="accent" mat-dialog-close [disabled]="!eidForm.valid" (click)="submit()">Submit</button>
  </div>
</ng-dialog-footer>
